import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { locationService } from 'shared/services';
import toast from 'shared/utils/toast';
import LocationForm from '../components/LocationForm';
import { Location } from '../types';

const initLocation: Location = {
  id: null,
  code: '',
  description: '',
  warehouse: null
};

export const CreateLocation = () => {
  const translationPrefix = 'pages.locations.new';

  const { t } = useTranslation();
  const navigate = useNavigate();

  const createLocation = async (values) => {
    locationService.add(values).then((res) => {
      toast.crud.successCreate('Piazza', 'f');
      navigate(`../${res.id}`);
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <LocationForm location={initLocation} onSubmit={createLocation} />
    </TenantPage>
  );
};

export default CreateLocation;
